module.exports = __webpack_public_path__ + "static/q13_o-695196e34beac544d150a30eb0fc3f28.png";